module.exports = __webpack_public_path__ + "img/portfolio-10-481x325.b221b94e.jpg";